export default "__VITE_ASSET__Bii49QtO__"